import { useState, FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import authService from '../../services/authService'

export const ForgotPasswordPage = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setError('')
    setIsLoading(true)

    try {
      await authService.requestPasswordReset(email)
      setSuccess(true)
    } catch (err: any) {
      setError(
        err.response?.data?.error ||
        err.response?.data?.detail ||
        'Erro ao enviar email. Tente novamente.'
      )
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="max-w-md w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="/logo-jonnpo.png"
            alt="Jonnpo"
            className="h-14 mx-auto mb-3 dark:hidden"
          />
          <img
            src="/logo-jonnpo-dark.png"
            alt="Jonnpo"
            className="h-14 mx-auto mb-3 hidden dark:block"
          />
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Ownership
          </h1>
        </div>

        {/* Card */}
        <div className="bg-white dark:bg-gray-800 rounded-card shadow-lg p-8">
          {success ? (
            <>
              <div className="text-center">
                <div className="mx-auto w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3">
                  Email Enviado
                </h2>
                <p className="text-gray-600 dark:text-gray-400 text-sm mb-6">
                  Se o email <strong>{email}</strong> estiver cadastrado, você receberá um código de 6 dígitos para redefinir sua senha. Verifique sua caixa de entrada e spam.
                </p>
              </div>

              <button
                onClick={() => navigate('/redefinir-senha', { state: { email } })}
                className="block w-full py-3 px-4 bg-primary hover:bg-primary-hover text-white font-medium rounded-btn transition-colors text-center mb-3"
              >
                Já tenho o código
              </button>

              <Link
                to="/login"
                className="block w-full py-3 px-4 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 font-medium rounded-btn transition-colors text-center hover:bg-gray-50 dark:hover:bg-gray-700"
              >
                Voltar ao Login
              </Link>
            </>
          ) : (
            <>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">
                Esqueceu sua senha?
              </h2>
              <p className="text-gray-600 dark:text-gray-400 text-sm mb-6">
                Informe seu email e enviaremos um código de 6 dígitos para redefinir sua senha.
              </p>

              {/* Error */}
              {error && (
                <div className="mb-4 p-3 bg-danger/10 border border-danger rounded-btn text-danger text-sm">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-6">
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                  >
                    Email
                  </label>
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-btn bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-transparent"
                    placeholder="seu@email.com"
                    required
                    autoFocus
                  />
                </div>

                <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full py-3 px-4 bg-primary hover:bg-primary-hover text-white font-medium rounded-btn transition-colors disabled:opacity-50 disabled:cursor-not-allowed mb-4"
                >
                  {isLoading ? 'Enviando...' : 'Enviar Código'}
                </button>

                <Link
                  to="/login"
                  className="block text-center text-sm text-primary hover:text-primary-hover transition-colors"
                >
                  Voltar ao Login
                </Link>
              </form>
            </>
          )}
        </div>

        {/* Footer */}
        <p className="text-center text-sm text-gray-500 dark:text-gray-400 mt-8">
          Sistema de pontuação por atitudes
        </p>
      </div>
    </div>
  )
}

export default ForgotPasswordPage
